import { fetchAPI } from "features/cms";
import { buildWidgetInstanceId } from "features/widgets";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useCollectedData } from "shared/contexts/PageData";

const FETCH_INCREMENT = 4;
const ITEMS_NUMBER = {
  three: 3,
  five: 5,
};

export const useCollectedEventsRender = ({ payload }) => {
  const { locale } = useRouter();
  const itemsAmount = payload?.itemsAmount ?? "three";
  const eventCategories = payload?.eventCategories;
  const eventCategoriesSlugs = eventCategories?.map(({ slug }) => slug);
  const eventsType = payload?.eventType ?? "active";
  const eventsTypeBoolean = Boolean(eventsType === "active");

  const instanceId = buildWidgetInstanceId("027", payload.id);
  const { events } = useCollectedData(instanceId, [
    { name: "events", defaultValue: [] },
  ]);

  const [limit, setLimit] = useState(ITEMS_NUMBER[itemsAmount]);
  const [fetchStart, setFetchStart] = useState(ITEMS_NUMBER[itemsAmount]);

  const [feed, setFeed] = useState(events);

  useEffect(() => {
    if (feed.length < limit) {
      const collectedDataRender = async () => {
        const nextEvents = (await fetchAPI(
          `/events`,
          {
            pagination: {
              start: fetchStart,
              limit: FETCH_INCREMENT,
            },
            populate: {
              previewImage: "*",
              eventCategories: { populate: "*" },
            },

            sort: "eventDate",
            filters: {
              eventCategories: {
                slug: {
                  $in:
                    eventCategoriesSlugs.length > 0
                      ? eventCategoriesSlugs
                      : null,
                },
              },
              active: {
                $eq: eventsTypeBoolean,
              },
            },
          },
          locale
        )) ?? { data: [] };

        const temporaryEvents = nextEvents?.data;

        setFeed((currentFeed) => [...currentFeed, ...temporaryEvents]);
        setFetchStart(
          (currentFetchStart) => currentFetchStart + FETCH_INCREMENT
        );
      };

      collectedDataRender();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit]);

  const isCompleted = useMemo(() => feed.length < limit, [feed.length, limit]);

  const renderNext = useCallback(() => {
    if (!isCompleted) {
      setLimit((limit) => limit + FETCH_INCREMENT);
    }
  }, [isCompleted]);

  return { feed, isCompleted, renderNext, itemsAmount, limit };
};
